import { render, staticRenderFns } from "./experimentInfo.vue?vue&type=template&id=ae1d22da&scoped=true&"
import script from "./experimentInfo.vue?vue&type=script&lang=js&"
export * from "./experimentInfo.vue?vue&type=script&lang=js&"
import style0 from "./experimentInfo.vue?vue&type=style&index=0&id=ae1d22da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1d22da",
  null
  
)

export default component.exports